import Vue from 'vue';

let OperationTypeEnum = {
    Modified: 'Modified',
    Deleted: 'Deleted',
    Added: 'Added'
};

let OperationTypeOptions = [
    { value: OperationTypeEnum.Modified, text: Vue.i18n.$t('[[[Modyfikacja]]]') },
    { value: OperationTypeEnum.Deleted, text: Vue.i18n.$t('[[[Usunięcie]]]') },
    { value: OperationTypeEnum.Added, text: Vue.i18n.$t('[[[Dodanie]]]') }
];

class OperationTypeTranslator
{
    static translate(enumValue)
    {
        switch (enumValue)
        {
            case OperationTypeEnum.Modified:
                return Vue.i18n.$t('[[[Modyfikacja]]]');
            case OperationTypeEnum.Deleted:
                return Vue.i18n.$t('[[[Usunięcie]]]');
            case OperationTypeEnum.Added:
                return Vue.i18n.$t('[[[Dodanie]]]');
            default:
                return Vue.i18n.$t('[[[Inna operacja]]]');
        }
    }
}

export {
    OperationTypeEnum,
    OperationTypeOptions,
    OperationTypeTranslator
};
